import { requestFromServer } from "./api-client";

const Docks = {
  listByBranch: async (idBranch) => {
    return requestFromServer(`v1/Docks/list/${idBranch}`);
  },
  add: async (dock) => {
    return requestFromServer(`v1/Docks/add`, "POST", dock);
  },
  update: async (dock) => {
    return requestFromServer(`v1/Docks/update/${dock.id}`, "PUT", dock);
  },
  delete: async (id, idPlant) => {
    return requestFromServer(`v1/Docks/delete/${id}/${idPlant}`, "delete");
  },
  getCapacityByTimeBlock: async (payload) => {
    const { plantId, idBranch } = payload;
    return requestFromServer(
      `v1/Docks/getDocksCapacityByTimeBlock/${plantId}/${idBranch}`
    );
  },
};

export default Docks;
